/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type BuyerSavedSearchCreateInput = {
  savedSearch: SavedSearchInput;
};

export type BuyerSavedSearchDeleteInput = {
  id: Types.Scalars['NonEmptyString']['input'];
};

export type BuyerSavedSearchUpdateInput = {
  id: Types.Scalars['NonEmptyString']['input'];
  savedSearch: SavedSearchInput;
};

export type SavedSearchFiltersInput = {
  fhaEligibleOnly?: Types.Scalars['Boolean']['input'] | null | undefined;
  hasPoolOnly?: Types.Scalars['Boolean']['input'] | null | undefined;
  maxBathrooms?: Types.Scalars['Float']['input'] | null | undefined;
  maxBedrooms?: Types.Scalars['SafeInt']['input'] | null | undefined;
  maxLotSqft?: Types.Scalars['SafeInt']['input'] | null | undefined;
  maxMonthlyHoaFeeDollars?: Types.Scalars['SafeInt']['input'] | null | undefined;
  maxPriceDollars?: Types.Scalars['SafeInt']['input'] | null | undefined;
  maxSqft?: Types.Scalars['SafeInt']['input'] | null | undefined;
  maxYearBuilt?: Types.Scalars['SafeInt']['input'] | null | undefined;
  minBathrooms?: Types.Scalars['Float']['input'] | null | undefined;
  minBedrooms?: Types.Scalars['SafeInt']['input'] | null | undefined;
  minLotSqft?: Types.Scalars['SafeInt']['input'] | null | undefined;
  minPriceDollars?: Types.Scalars['SafeInt']['input'] | null | undefined;
  minSqft?: Types.Scalars['SafeInt']['input'] | null | undefined;
  minYearBuilt?: Types.Scalars['SafeInt']['input'] | null | undefined;
  opendoorOwnedOnly?: Types.Scalars['Boolean']['input'] | null | undefined;
  propertyTypes?: Array<SavedSearchPropertyType> | null | undefined;
  selfTourableOnly?: Types.Scalars['Boolean']['input'] | null | undefined;
  singleStoryOnly?: Types.Scalars['Boolean']['input'] | null | undefined;
};

export type SavedSearchInput = {
  filters: SavedSearchFiltersInput;
  location: SavedSearchLocationInput;
  name: Types.Scalars['NonEmptyString']['input'];
};

export type SavedSearchLocationInput = {
  market?: Types.Scalars['NonEmptyString']['input'] | null | undefined;
  vertices?: Array<SavedSearchPointInput> | null | undefined;
  zoneIds?: Array<Types.Scalars['UUID']['input']> | null | undefined;
};

export type SavedSearchPointInput = {
  lat: Types.Scalars['Latitude']['input'];
  lon: Types.Scalars['Longitude']['input'];
};

export type SavedSearchPropertyType =
  | 'CONDO'
  | 'HOME'
  | 'TOWNHOME';

export type SavedSearchFieldsFragment = { id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], location: { market: Types.Scalars['NonEmptyString']['output'] | null, zoneIds: Array<Types.Scalars['UUID']['output']>, vertices: Array<{ lat: Types.Scalars['Latitude']['output'], lon: Types.Scalars['Longitude']['output'] }>, zones: Array<{ name: Types.Scalars['NonEmptyString']['output'] }> }, filters: { minPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxMonthlyHoaFeeDollars: Types.Scalars['SafeInt']['output'] | null, minBedrooms: Types.Scalars['SafeInt']['output'] | null, maxBedrooms: Types.Scalars['SafeInt']['output'] | null, minBathrooms: Types.Scalars['Float']['output'] | null, maxBathrooms: Types.Scalars['Float']['output'] | null, minSqft: Types.Scalars['SafeInt']['output'] | null, maxSqft: Types.Scalars['SafeInt']['output'] | null, minLotSqft: Types.Scalars['SafeInt']['output'] | null, maxLotSqft: Types.Scalars['SafeInt']['output'] | null, minYearBuilt: Types.Scalars['SafeInt']['output'] | null, maxYearBuilt: Types.Scalars['SafeInt']['output'] | null, opendoorOwnedOnly: Types.Scalars['Boolean']['output'], selfTourableOnly: Types.Scalars['Boolean']['output'], singleStoryOnly: Types.Scalars['Boolean']['output'], hasPoolOnly: Types.Scalars['Boolean']['output'], fhaEligibleOnly: Types.Scalars['Boolean']['output'], propertyTypes: Array<Types.SavedSearchPropertyType> } };

export type MarketplaceSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceSavedSearchesQuery = { customerAccount: { buyer: { savedSearches: Array<{ id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], location: { market: Types.Scalars['NonEmptyString']['output'] | null, zoneIds: Array<Types.Scalars['UUID']['output']>, vertices: Array<{ lat: Types.Scalars['Latitude']['output'], lon: Types.Scalars['Longitude']['output'] }>, zones: Array<{ name: Types.Scalars['NonEmptyString']['output'] }> }, filters: { minPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxMonthlyHoaFeeDollars: Types.Scalars['SafeInt']['output'] | null, minBedrooms: Types.Scalars['SafeInt']['output'] | null, maxBedrooms: Types.Scalars['SafeInt']['output'] | null, minBathrooms: Types.Scalars['Float']['output'] | null, maxBathrooms: Types.Scalars['Float']['output'] | null, minSqft: Types.Scalars['SafeInt']['output'] | null, maxSqft: Types.Scalars['SafeInt']['output'] | null, minLotSqft: Types.Scalars['SafeInt']['output'] | null, maxLotSqft: Types.Scalars['SafeInt']['output'] | null, minYearBuilt: Types.Scalars['SafeInt']['output'] | null, maxYearBuilt: Types.Scalars['SafeInt']['output'] | null, opendoorOwnedOnly: Types.Scalars['Boolean']['output'], selfTourableOnly: Types.Scalars['Boolean']['output'], singleStoryOnly: Types.Scalars['Boolean']['output'], hasPoolOnly: Types.Scalars['Boolean']['output'], fhaEligibleOnly: Types.Scalars['Boolean']['output'], propertyTypes: Array<Types.SavedSearchPropertyType> } }> } } };

export type MarketplaceCreateSavedSearchMutationVariables = Exact<{
  input: Types.BuyerSavedSearchCreateInput;
}>;


export type MarketplaceCreateSavedSearchMutation = { buyerSavedSearchCreate:
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'SavedSearch', id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], location: { market: Types.Scalars['NonEmptyString']['output'] | null, zoneIds: Array<Types.Scalars['UUID']['output']>, vertices: Array<{ lat: Types.Scalars['Latitude']['output'], lon: Types.Scalars['Longitude']['output'] }>, zones: Array<{ name: Types.Scalars['NonEmptyString']['output'] }> }, filters: { minPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxMonthlyHoaFeeDollars: Types.Scalars['SafeInt']['output'] | null, minBedrooms: Types.Scalars['SafeInt']['output'] | null, maxBedrooms: Types.Scalars['SafeInt']['output'] | null, minBathrooms: Types.Scalars['Float']['output'] | null, maxBathrooms: Types.Scalars['Float']['output'] | null, minSqft: Types.Scalars['SafeInt']['output'] | null, maxSqft: Types.Scalars['SafeInt']['output'] | null, minLotSqft: Types.Scalars['SafeInt']['output'] | null, maxLotSqft: Types.Scalars['SafeInt']['output'] | null, minYearBuilt: Types.Scalars['SafeInt']['output'] | null, maxYearBuilt: Types.Scalars['SafeInt']['output'] | null, opendoorOwnedOnly: Types.Scalars['Boolean']['output'], selfTourableOnly: Types.Scalars['Boolean']['output'], singleStoryOnly: Types.Scalars['Boolean']['output'], hasPoolOnly: Types.Scalars['Boolean']['output'], fhaEligibleOnly: Types.Scalars['Boolean']['output'], propertyTypes: Array<Types.SavedSearchPropertyType> } }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export type MarketplaceUpdateSavedSearchMutationVariables = Exact<{
  input: Types.BuyerSavedSearchUpdateInput;
}>;


export type MarketplaceUpdateSavedSearchMutation = { buyerSavedSearchUpdate:
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'SavedSearch', id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], location: { market: Types.Scalars['NonEmptyString']['output'] | null, zoneIds: Array<Types.Scalars['UUID']['output']>, vertices: Array<{ lat: Types.Scalars['Latitude']['output'], lon: Types.Scalars['Longitude']['output'] }>, zones: Array<{ name: Types.Scalars['NonEmptyString']['output'] }> }, filters: { minPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxPriceDollars: Types.Scalars['SafeInt']['output'] | null, maxMonthlyHoaFeeDollars: Types.Scalars['SafeInt']['output'] | null, minBedrooms: Types.Scalars['SafeInt']['output'] | null, maxBedrooms: Types.Scalars['SafeInt']['output'] | null, minBathrooms: Types.Scalars['Float']['output'] | null, maxBathrooms: Types.Scalars['Float']['output'] | null, minSqft: Types.Scalars['SafeInt']['output'] | null, maxSqft: Types.Scalars['SafeInt']['output'] | null, minLotSqft: Types.Scalars['SafeInt']['output'] | null, maxLotSqft: Types.Scalars['SafeInt']['output'] | null, minYearBuilt: Types.Scalars['SafeInt']['output'] | null, maxYearBuilt: Types.Scalars['SafeInt']['output'] | null, opendoorOwnedOnly: Types.Scalars['Boolean']['output'], selfTourableOnly: Types.Scalars['Boolean']['output'], singleStoryOnly: Types.Scalars['Boolean']['output'], hasPoolOnly: Types.Scalars['Boolean']['output'], fhaEligibleOnly: Types.Scalars['Boolean']['output'], propertyTypes: Array<Types.SavedSearchPropertyType> } }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export type MarketplaceDeleteSavedSearchMutationVariables = Exact<{
  input: Types.BuyerSavedSearchDeleteInput;
}>;


export type MarketplaceDeleteSavedSearchMutation = { buyerSavedSearchDelete:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const SavedSearchFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SavedSearchFields on SavedSearch {
  id
  name
  location {
    market
    zoneIds
    vertices {
      lat
      lon
    }
    zones {
      name
    }
  }
  filters {
    minPriceDollars
    maxPriceDollars
    maxMonthlyHoaFeeDollars
    minBedrooms
    maxBedrooms
    minBathrooms
    maxBathrooms
    minSqft
    maxSqft
    minLotSqft
    maxLotSqft
    minYearBuilt
    maxYearBuilt
    opendoorOwnedOnly
    selfTourableOnly
    singleStoryOnly
    hasPoolOnly
    fhaEligibleOnly
    propertyTypes
  }
}
    `, {"fragmentName":"SavedSearchFields"}) as unknown as TypedDocumentString<SavedSearchFieldsFragment, unknown>;
export const MarketplaceSavedSearchesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceSavedSearches {
  customerAccount {
    buyer {
      savedSearches {
        ...SavedSearchFields
      }
    }
  }
}
    fragment SavedSearchFields on SavedSearch {
  id
  name
  location {
    market
    zoneIds
    vertices {
      lat
      lon
    }
    zones {
      name
    }
  }
  filters {
    minPriceDollars
    maxPriceDollars
    maxMonthlyHoaFeeDollars
    minBedrooms
    maxBedrooms
    minBathrooms
    maxBathrooms
    minSqft
    maxSqft
    minLotSqft
    maxLotSqft
    minYearBuilt
    maxYearBuilt
    opendoorOwnedOnly
    selfTourableOnly
    singleStoryOnly
    hasPoolOnly
    fhaEligibleOnly
    propertyTypes
  }
}`) as unknown as TypedDocumentString<MarketplaceSavedSearchesQuery, MarketplaceSavedSearchesQueryVariables>;
export const MarketplaceCreateSavedSearchDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MarketplaceCreateSavedSearch($input: BuyerSavedSearchCreateInput!) {
  buyerSavedSearchCreate(input: $input) {
    __typename
    ... on SavedSearch {
      ...SavedSearchFields
    }
    ... on Error {
      message
    }
  }
}
    fragment SavedSearchFields on SavedSearch {
  id
  name
  location {
    market
    zoneIds
    vertices {
      lat
      lon
    }
    zones {
      name
    }
  }
  filters {
    minPriceDollars
    maxPriceDollars
    maxMonthlyHoaFeeDollars
    minBedrooms
    maxBedrooms
    minBathrooms
    maxBathrooms
    minSqft
    maxSqft
    minLotSqft
    maxLotSqft
    minYearBuilt
    maxYearBuilt
    opendoorOwnedOnly
    selfTourableOnly
    singleStoryOnly
    hasPoolOnly
    fhaEligibleOnly
    propertyTypes
  }
}`) as unknown as TypedDocumentString<MarketplaceCreateSavedSearchMutation, MarketplaceCreateSavedSearchMutationVariables>;
export const MarketplaceUpdateSavedSearchDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MarketplaceUpdateSavedSearch($input: BuyerSavedSearchUpdateInput!) {
  buyerSavedSearchUpdate(input: $input) {
    __typename
    ... on SavedSearch {
      ...SavedSearchFields
    }
    ... on Error {
      message
    }
  }
}
    fragment SavedSearchFields on SavedSearch {
  id
  name
  location {
    market
    zoneIds
    vertices {
      lat
      lon
    }
    zones {
      name
    }
  }
  filters {
    minPriceDollars
    maxPriceDollars
    maxMonthlyHoaFeeDollars
    minBedrooms
    maxBedrooms
    minBathrooms
    maxBathrooms
    minSqft
    maxSqft
    minLotSqft
    maxLotSqft
    minYearBuilt
    maxYearBuilt
    opendoorOwnedOnly
    selfTourableOnly
    singleStoryOnly
    hasPoolOnly
    fhaEligibleOnly
    propertyTypes
  }
}`) as unknown as TypedDocumentString<MarketplaceUpdateSavedSearchMutation, MarketplaceUpdateSavedSearchMutationVariables>;
export const MarketplaceDeleteSavedSearchDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MarketplaceDeleteSavedSearch($input: BuyerSavedSearchDeleteInput!) {
  buyerSavedSearchDelete(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
    ... on Error {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<MarketplaceDeleteSavedSearchMutation, MarketplaceDeleteSavedSearchMutationVariables>;